'use client';

import { c as _c } from "react/compiler-runtime";
import { DataList } from '@morpho-org/ui-v6/client';
import { Skeleton } from '@morpho-org/ui-v6/server';
import { SubSectionTitle } from '@/components/common/SubSectionTitle';

/** Mirrors `VaultFees`: performance fee, then its recipient. */
const VaultFeesLoading = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SubSectionTitle>Fees</SubSectionTitle>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DataList.Column><DataList.Line><Skeleton className="h-md w-[100%] rounded-[20px]" /></DataList.Line></DataList.Column>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="gap-2xs flex w-[100%] flex-col items-start">{t0}<DataList.Root fullWidth={true}>{t1}<DataList.Column><DataList.Line><Skeleton className="h-md w-[100%] rounded-[20px]" /></DataList.Line></DataList.Column></DataList.Root></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default VaultFeesLoading;